import React, { useContext } from 'react';
import classNames from 'classnames';

import { media } from 'context';

import { Direction } from './types';
import Icon from '../Icon';
import Layout from '../Layout';

interface Props {
  activeSortDirection?: Direction;
  sortable: boolean;
}

const SortControls: React.FC<Props> = ({ activeSortDirection, sortable }) => {
  const { isTouchScreen } = useContext(media);
  const isAsc = activeSortDirection === 'asc';
  const isDesc = activeSortDirection === 'desc';

  return (
    <>
      {isAsc && <Icon name="sortAsc" color="blue-500" size="md" />}
      {isDesc && <Icon name="sortDesc" color="blue-500" size="md" />}
      {sortable && !activeSortDirection && (
        <Layout
          __className={classNames('Table-defaultSortIcon', {
            'is-sortable': sortable,
            'is-sort_active': !!activeSortDirection,
            'is-sort-not-active': !activeSortDirection,
            'is-touch': isTouchScreen
          })}
          display="inline-flex"
        >
          <Icon name="sortControl" color="gray-200" size="md" />
        </Layout>
      )}
    </>
  );
};

export default SortControls;
